import { render, staticRenderFns } from "./radiology_report.vue?vue&type=template&id=6813adb1&scoped=true&"
import script from "./radiology_report.vue?vue&type=script&lang=js&"
export * from "./radiology_report.vue?vue&type=script&lang=js&"
import style0 from "./radiology_report.vue?vue&type=style&index=0&id=6813adb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6813adb1",
  null
  
)

export default component.exports